import { inject, Injectable, signal } from '@angular/core';
import { ApiService } from './api.service';

export type ThemeMode = 'light' | 'dark';
const STORAGE_KEY = 'orgdocs-theme';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly api = inject(ApiService);

  readonly mode = signal<ThemeMode>(this.loadCached());

  constructor() {
    this.applyTheme(this.mode());
  }

  /** Called after profile API response — syncs server-stored preference. */
  syncFromProfile(preference: string | null | undefined): void {
    const pref = preference === 'dark' ? 'dark' : 'light';
    this.mode.set(pref);
    this.applyTheme(pref);
    localStorage.setItem(STORAGE_KEY, pref);
  }

  toggle(): void {
    const next: ThemeMode = this.mode() === 'light' ? 'dark' : 'light';
    this.mode.set(next);
    this.applyTheme(next);
    localStorage.setItem(STORAGE_KEY, next);
    this.api.patch('/api/profile', { theme_preference: next }).subscribe();
  }

  private loadCached(): ThemeMode {
    const s = localStorage.getItem(STORAGE_KEY);
    if (s === 'light' || s === 'dark') return s;
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }

  private applyTheme(t: ThemeMode): void {
    document.body.setAttribute('data-theme', t);
  }
}
